/**
 * 检测是否支持监控某种变化类型
 * @param entryType 
 * @returns 
 */ export var supportedEntryType = function(entryType) {
    return typeof PerformanceObserver === "function" && Array.isArray(PerformanceObserver.supportedEntryTypes) && PerformanceObserver.supportedEntryTypes.indexOf(entryType) > -1;
};
